import * as React from "react";
import { SVGProps } from "react";

export const SVGIconDirectOffer = ({
  iconColor,
  ...props
}: SVGProps<SVGSVGElement> & { iconColor?: string }) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.3691 22H4.6213C3.69957 21.9973 2.95266 21.2517 2.95 20.33V11.27C2.94868 10.6052 3.342 10.0039 3.95121 9.73905L4.72329 9.40268L4.52067 10.2198C4.4571 10.4847 4.53524 10.7641 4.72859 10.9561L9.85924 16.0825L11.0736 15.0826C11.6683 14.5873 12.5317 14.5873 13.1277 15.0826L14.0891 15.8772L19.2079 10.7562C19.3695 10.5946 19.4516 10.3695 19.4357 10.1417L19.3801 9.45571L20.0131 9.72587V9.72455C20.6355 9.98544 21.0408 10.5933 21.0421 11.2674V20.3274C21.0408 20.9008 20.7455 21.4345 20.2608 21.7418L20.1773 21.8331H20.0939C19.8688 21.9431 19.6198 22 19.3695 22L19.3691 22ZM3.80933 11.0677C3.79211 11.1339 3.78416 11.2014 3.78416 11.2703V20.3303C3.78416 20.7912 4.15896 21.166 4.62114 21.166H19.3689C19.4934 21.1673 19.6166 21.1395 19.7291 21.0852L19.8046 21.0017H19.8656C20.0761 20.8428 20.2006 20.5938 20.2019 20.3303V11.2703C20.2019 11.1405 20.1715 11.012 20.1132 10.8955C20.0337 11.0637 19.9251 11.2173 19.794 11.3484L14.139 17.0062L12.5935 15.7283C12.3061 15.4886 11.889 15.4886 11.6016 15.7283L9.80317 17.2129L4.14024 11.5528V11.5514C3.99986 11.4137 3.8873 11.2508 3.80915 11.0707L3.80933 11.0677Z"
      fill={iconColor ?? "url(#paint0_linear_1_38227)"}
    />
    <path
      d="M19.9995 21.8358H4.19903C4.02289 21.8358 3.86531 21.7259 3.80702 21.5604C3.74743 21.3948 3.79908 21.2107 3.93416 21.0995L11.0738 15.1998C11.6685 14.7059 12.5319 14.7059 13.1279 15.1998L20.2676 21.0995H20.2662C20.4026 21.2107 20.4543 21.3948 20.3947 21.5604C20.3351 21.7259 20.1788 21.8358 20.0027 21.8358H19.9995ZM5.35738 21.0015H18.8406L12.5937 15.8403V15.8417C12.3063 15.602 11.8891 15.602 11.6018 15.8417L5.35486 21.0051L5.35738 21.0015Z"
      fill={iconColor ?? "url(#paint1_linear_1_38227)"}
    />
    <path
      d="M15.706 5.97432H8.43017C8.26198 5.973 8.10967 5.87102 8.04477 5.71475C7.97856 5.5598 8.01564 5.3797 8.13615 5.26184L10.9239 2.47411V2.47543C11.2271 2.17084 11.639 2 12.0681 2C12.4985 2 12.9104 2.17084 13.2137 2.47543L16.0014 5.26316L16.0001 5.26184C16.1193 5.38103 16.155 5.56114 16.0901 5.71608C16.0265 5.87235 15.8742 5.973 15.7061 5.97432L15.706 5.97432ZM9.4368 5.14H14.6997L12.6244 3.06477C12.3132 2.76679 11.8232 2.76679 11.512 3.06477L9.4368 5.14Z"
      fill={iconColor ?? "url(#paint2_linear_1_38227)"}
    />
    <path
      d="M9.83111 17.0643C9.72119 17.0643 9.61525 17.0206 9.53712 16.9424L4.14033 11.5485C3.74172 11.1485 3.58014 10.5711 3.71123 10.0228C3.7801 9.73412 3.9271 9.47058 4.13635 9.26134L5.20641 8.19128V6.78747C5.20906 5.87766 5.94671 5.14131 6.85785 5.14001H17.3426C18.2524 5.14134 18.9888 5.87766 18.9901 6.78747V8.25485L19.7966 9.06137C20.0999 9.36463 20.2707 9.7752 20.2707 10.2043C20.2707 10.6333 20.0999 11.0452 19.7966 11.3485L14.4077 16.7374C14.2554 16.8897 14.0131 16.9016 13.8462 16.7639L12.5934 15.7269V15.7282C12.306 15.4885 11.8888 15.4885 11.6015 15.7282L10.0957 16.9705H10.0944C10.0202 17.0314 9.92751 17.0645 9.83083 17.0645L9.83111 17.0643ZM6.85811 5.97291V5.97424C6.40782 5.97291 6.04099 6.33711 6.04099 6.78737V8.36332C6.04099 8.47457 5.99729 8.58051 5.91782 8.65864L4.72857 9.8479C4.42398 10.1551 4.42398 10.6518 4.72857 10.959L9.85921 16.0854L11.0736 15.0855C11.6682 14.5916 12.5317 14.5916 13.1277 15.0855L14.0891 15.8801L19.2079 10.7591C19.3695 10.5975 19.4516 10.3724 19.4357 10.1446C19.4224 9.95788 19.3403 9.78173 19.2079 9.65064L18.2795 8.7223C18.2014 8.64416 18.1577 8.53821 18.1577 8.42697V6.78745C18.1577 6.57159 18.0716 6.365 17.9193 6.21269C17.7657 6.05906 17.5591 5.97298 17.3432 5.97431H6.85846L6.85811 5.97291ZM12.0998 13.5559L12.0985 13.5572C11.9885 13.5572 11.8826 13.5135 11.8045 13.4354L9.70672 11.3376V11.3363C9.3465 10.9973 9.12401 10.5377 9.08031 10.0451C9.03528 9.25179 9.48423 8.51282 10.2087 8.18834C10.8298 7.90096 11.5595 7.98307 12.1011 8.40289C12.5964 8.05459 13.2361 7.98571 13.7936 8.2188C14.5299 8.51811 15.0239 9.22002 15.0584 10.0146C15.0597 10.5152 14.8544 10.9959 14.4889 11.3389L12.3912 13.4367V13.438C12.313 13.5161 12.2071 13.5598 12.0958 13.5598L12.0998 13.5559ZM10.9714 8.85043L10.9701 8.85175C10.8271 8.85307 10.6867 8.88486 10.5569 8.94445C10.149 9.12721 9.89344 9.54041 9.91198 9.98671C9.94111 10.2781 10.0762 10.5496 10.2921 10.7482L12.0958 12.552L13.8996 10.7482C14.1035 10.5615 14.2214 10.3006 14.224 10.0251C14.1949 9.56555 13.9062 9.16428 13.4797 8.99081C13.101 8.83189 12.6639 8.93254 12.3938 9.24111C12.3156 9.32057 12.2097 9.36428 12.0984 9.36428C11.9885 9.36428 11.8826 9.32057 11.8044 9.24111C11.5899 9.00538 11.2893 8.86632 10.9701 8.85572L10.9714 8.85043Z"
      fill={iconColor ?? "url(#paint3_linear_1_38227)"}
    />
    <path
      d="M12.0986 13.7296L9.70551 11.3365H9.70683C9.34661 10.9975 9.12412 10.538 9.08042 10.0453C9.03539 9.25205 9.48434 8.51308 10.2088 8.1886C10.8299 7.90122 11.5596 7.98333 12.1012 8.40314C12.5965 8.05485 13.2362 7.98597 13.7937 8.21906C14.53 8.51837 15.024 9.22027 15.0585 10.0148C15.0598 10.5155 14.8545 10.9962 14.489 11.3392L12.0959 13.7322L12.0986 13.7296ZM10.9702 8.85211C10.8272 8.85343 10.6868 8.88522 10.557 8.94481C10.1491 9.12757 9.89355 9.54077 9.91209 9.98707C9.94122 10.2784 10.0763 10.5499 10.2922 10.7486L12.0959 12.5523L13.8997 10.7486C14.1036 10.5618 14.2215 10.3009 14.2241 10.0255C14.195 9.56591 13.9063 9.16464 13.4798 8.99117C13.1011 8.83225 12.664 8.9329 12.3939 9.24147L12.0999 9.53547L11.8059 9.24147H11.8046C11.59 9.00574 11.2894 8.86668 10.9702 8.85608L10.9702 8.85211Z"
      fill={iconColor ?? "url(#paint4_linear_1_38227)"}
    />
    <path d="M5.20647 7.58612H6.04079V12.4438H5.20647V7.58612Z" fill={iconColor ?? "url(#paint5_linear_1_38227)"} />
    <path d="M18.1505 7.14368H18.9848V12.0014H18.1505V7.14368Z" fill={iconColor ?? "url(#paint6_linear_1_38227)"} />
    <defs>
      <linearGradient
        id="paint0_linear_1_38227"
        x1={8.44959}
        y1={9.40269}
        x2={2.58207}
        y2={9.62822}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_38227"
        x1={8.83968}
        y1={14.8294}
        x2={3.45795}
        y2={15.1713}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_38227"
        x1={10.4775}
        y1={2}
        x2={7.85127}
        y2={2.14342}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_38227"
        x1={8.71384}
        y1={5.14002}
        x2={3.3284}
        y2={5.34072}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_38227"
        x1={10.8955}
        y1={8.01905}
        x2={8.95434}
        y2={8.07343}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1_38227"
        x1={5.46008}
        y1={7.58612}
        x2={5.18911}
        y2={7.58737}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1_38227"
        x1={18.4041}
        y1={7.14368}
        x2={18.1331}
        y2={7.14493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D55EC" />
        <stop offset={1} stopColor="#DB4ACD" />
      </linearGradient>
    </defs>
  </svg>
);
